import { render, staticRenderFns } from "./DigitalSolution.vue?vue&type=template&id=4b8d6262&scoped=true"
import script from "./DigitalSolution.vue?vue&type=script&lang=js"
export * from "./DigitalSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d6262",
  null
  
)

export default component.exports